import { Method as apiMethod } from 'axios'

export const authEndpoints = {
  me: {
    method: 'get',
    url: '/me'
  },
  login: {
    method: 'post' as apiMethod,
    url: '/authentication/login'
  },
  logout: {
    method: 'post',
    url: '/authentication/logout'
  },
  forgot: {
    method: 'post',
    url: '/forgot'
  },
  reset: {
    method: 'post',
    url: '/reset'
  }
}
